import {stats} from "../../api";

export default {
    state: {
        stats: []
    },

    actions: {
        fetchStats(context, params = {}) {
            let token = context.getters.getToken.jwt;

            return stats({token, filters: {...params}})
                    .then(r => context.commit("setStats", r.data));
        }
    },

    mutations: {
        setStats(state, payload) {
            console.log("setStats payload", payload);
            state.stats = payload;
        }
    },

    getters: {}
}